
<div class="row mb-3">
  <div class="col-12">
    <h4 class="card-title">Ranking Das Taxas de Reciclagem</h4>
  </div>
</div>

<dg-table dg-dynamic-table [dynamicTable]="tableReciclagem"></dg-table>
